import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../context/ApiKeyContext";

/**
 * Hook para verificar permissão e redirecionar se não tiver acesso
 * @param {string} serviceName - Nome do serviço (ex: "DOCUMENT_CREATION")
 * @param {string|string[]} ruleCodeOrCodes - Uma regra ou lista (basta uma)
 * @param {string} redirectTo - Página para redirecionar (padrão: "/")
 */
const usePermissionRedirect = (serviceName, ruleCodeOrCodes, redirectTo = "/") => {
  const { hasRole } = useAuth();
  const history = useHistory();

  const codesKey = Array.isArray(ruleCodeOrCodes)
    ? ruleCodeOrCodes.join("\0")
    : ruleCodeOrCodes;

  useEffect(() => {
    const codes = Array.isArray(ruleCodeOrCodes)
      ? ruleCodeOrCodes
      : [ruleCodeOrCodes];
    const hasPermission = codes.some((code) => hasRole(serviceName, code));

    if (!hasPermission) {
      history.push(redirectTo);
    }
  }, [hasRole, history, serviceName, codesKey, redirectTo]);
};

export default usePermissionRedirect;
